import { useTranslation } from "react-i18next";

interface FriendlyDateProps {
  date: string; // Formato esperado: ISO string o "DD-MM-YYYY"
  locale?: string; // Opcional, por defecto "es-ES"
}

export const FriendlyDate: React.FC<FriendlyDateProps> = ({ date, locale = "es-ES" }) => {
  const { i18n } = useTranslation(); // Obtener el idioma actual de i18n

  const formatDate = (dateString: string, locale: string): string => {
    try {
      // Intentar parsear como fecha ISO
      const dateObj = new Date(dateString);
      
      // Verificar si la fecha es válida
      if (isNaN(dateObj.getTime())) {
        // Si no es una fecha ISO válida, intentar con formato DD-MM-YYYY
        const datePattern = /^\d{2}-\d{2}-\d{4}$/;
        if (!datePattern.test(dateString)) {
          return dateString;
        }
        const [day, month, year] = dateString.split("-").map(Number);
        const newDateObj = new Date(year, month - 1, day);
        if (isNaN(newDateObj.getTime())) {
          return dateString;
        }
        return new Intl.DateTimeFormat(locale, {
          weekday: "long",
          day: "numeric",
          month: "long",
          year: "numeric",
        }).format(newDateObj);
      }

      return new Intl.DateTimeFormat(locale, {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      }).format(dateObj);
    } catch (error) {
      return dateString;
    }
  };

  return <>{formatDate(date, i18n.language)}</>;
};
